// Test de live en local via tunnel : pdf.js fait un fetch (avec vérif CORS) sur le CDN R2 des
// webinaires, qui n'autorise pas le domaine trycloudflare -> "Impossible de charger le PDF".
// En mode proxy (VITE_API_URL=/v1), on réécrit l'URL du PDF vers /slides-cdn pour la servir en
// same-origin (proxy Vite). Hors mode proxy (dev normal, staging, prod) : no-op, on garde l'URL R2.
// Ne concerne que pdf.js ; les <img> ne subissent pas la vérif CORS.
export function toSlidesProxyUrl(url: string | undefined | null): string | undefined {
  if (!url) return url ?? undefined;
  if (import.meta.env.VITE_API_URL !== '/v1') return url;

  try {
    const parsed = new URL(url);
    if (!parsed.hostname.startsWith('webinars-resources-')) return url;
    return `/slides-cdn${parsed.pathname}${parsed.search}`;
  } catch {
    return url;
  }
}
